import { createReducer, on } from '@ngrx/store';
import { INIT_STATE_CONTACT } from '../init-data';
import { LoadContactPageSuccess } from '../actions';

export interface ContactState {
  firstBlockTitle: string;
  firstBlockText: string;
  secondBlockTitle: string;
  secondBlockText: string;
  form: {
    labels: {
      first_name: string;
      email: string;
      company_name: string;
      role: string;
      func: string;
      question: string;
      submit_button: string;
    };
    feedback: {
      error: string;
      success: string;
    }
  };

}

export const initialState: ContactState = INIT_STATE_CONTACT;

export const reducer = createReducer(
  initialState,
  on(LoadContactPageSuccess, (_, { page }) => ({
    ..._,
    firstBlockText: page.firstBlockText,
    firstBlockTitle: page.firstBlockTitle,
    form: page.form,
    secondBlockText: page.secondBlockText,
    secondBlockTitle: page.secondBlockTitle
  }))
);
